import { httpClient, HttpMethod } from './http-client';

export const getTimezones = (): any => {
  return httpClient('/timezones', HttpMethod.Get, null);
};